<template>
    <div class="container bg-gray">
        <!-- <van-nav-bar :title="title" left-arrow fixed :border="false" :z-index="999" class="nav-bar-primary"
            @click-left="goBack" /> -->
         <div class="custom-nav-bar">
            <van-icon name="arrow-left" @click="goBack" class="back-icon" />
            {{ title }}
         </div>
        <van-tabs v-model="activeTab" class="navtabswrap">
            <van-tab title="佣金">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
                    <div class="tab-content bill-detail">
                        <section v-if="commissionList.length > 0" v-for="item in commissionList" :key="item.id"
                            class="bill-box bg-white">
                            <div :class="item.settled ? 'c-green status-paid' : 'c-orange status-unpaid'">{{
                                item.settled ? '已发放' : '未发放' }}</div>
                            <div class="user-name">{{ item.name }}</div>
                            <div class="user-info">{{ item.customerName }}<span v-if="item.onJob"
                                    class="status-employed">在职</span></div>
                            <hr class="divider" />
                            <div class="attendance-info">本月已考勤：{{ item.attendance }}，佣金<span class="c-orange">{{
                                item.amount | formatFixed2 }}元</span></div>
                        </section>
                        <view v-if="commissionList.length === 0 && !loading" class="f14 c-gray empty">抱歉，暂无佣金明细哦~</view>
                    </div>
                </van-list>
            </van-tab>
            <van-tab title="下级贡献">
                <div class="tab-content">
                    <div class="tab-content bill-detail">
                        <p class="f14 c-gray empty">抱歉，暂无下级贡献明细哦~</p>
                        <!-- <div class="tab-content">
                            <section class="bill-box bg-white">
                                <div class="c-orange status-unpaid">未发放</div>
                                <div class="user-name">张三</div>
                                <hr class="divider" />
                                <div style="display: flex; text-align: center;">
                                    <div style="flex: 1;">
                                        <p>88</p><span>贡献人数</span>
                                    </div>
                                    <div style="flex: 1;">
                                        <p>8888</p><span>贡献佣金</span>
                                    </div>
                                </div>
                            </section>
                        </div> -->
                    </div>
                </div>
            </van-tab>
        </van-tabs>

        <!-- <tab-bar /> -->
    </div>
</template>

<script>
import tabBar from '../../components/tab-bar';

export default {
    name: 'my-bill-detail',
    components: { tabBar },
    data() {
        return {
            activeTab: 0,
            commissionList: [],
            allCommissionList: [],
            loading: false,
            finished: false,
            pageNum: 1,
            pageSize: 10
        };
    },
    computed: {
        title() {
            const month = this.$route.query.month || '';
            return `${month}收益明细`;
        }
    },
    mounted() {
        // 可以在这里调用API获取详情数据
        this.loadDetail();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        async loadDetail() {
            const month = this.$route.query.month;
            const res = await this.$store.dispatch('getData', {
                url: '/api/vpai/vleader/statistics/monthDetail?month=' + month,
            });
            if (res) {
                console.log('获取收益明细数据:', res);
                this.allCommissionList = res;
                this.commissionList = this.allCommissionList.slice(0, this.pageSize);
                this.finished = this.allCommissionList.length <= this.pageSize;
            }
        },
        async loadMore() {
            try {
                this.loading = true;
                const start = (this.pageNum - 1) * this.pageSize;
                const end = this.pageNum * this.pageSize;
                const newData = this.allCommissionList.slice(start, end);
                this.commissionList.push(...newData);
                this.pageNum++;
                if (this.commissionList.length >= this.allCommissionList.length) {
                    this.finished = true;
                }
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="less">
@import '../../assets/css/theme.less';

.custom-nav-bar {
    background-color: #FD6404;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    height: 46px;
    line-height: 46px;
    text-align: center;
}

.back-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    cursor: pointer;
}

.bill-detail {
    padding: 40px 15px 10px;
}

.navtabswrap .van-tabs__wrap{
    -webkit-position: fixed;
    position: fixed;
    top: 46px;
    left: 0;
    z-index: 100;
    background: #fff;
    width: 100%;
}


.bill-detail .bill-box {
    padding: 10px 20px 8px 20px;
    margin: 15px 5px;
    border-radius: 5px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
}

.status-unpaid {
    float: right;
}

.status-paid {
    float: right;
}

.user-name {
    margin-bottom: 10px;
}

.user-info {
    margin-bottom: 10px;
    font-size: 14px;
}

.status-employed {
    display: inline-block;
    padding: 0 2px;
    color: #fff;
    background: #ff6b35;
    font-size: 12px;
    border-radius: 3px;
}

.divider {
    border-color: #efeded;
    border-width: 1px;
    margin: 10px 0;
}

.attendance-info {
    margin: 10px 0;
    font-size: 14px;
}

.empty {
    text-align: center;
    padding: 50px 0;
    color: #999;
}
</style>